import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=355fec5a&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=355fec5a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355fec5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('355fec5a')) {
      api.createRecord('355fec5a', component.options)
    } else {
      api.reload('355fec5a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=355fec5a&scoped=true", function () {
      api.rerender('355fec5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/feedbackManagement/feedbackList/detail.vue"
export default component.exports